import React, {useState} from 'react';
import axios from "axios";
import moment from "moment";
import __ from "lodash";
import {Grid, InputLabel} from "@material-ui/core";

import {getApiSitePrefix} from "../../../functions/SiteDefaults";
import {DropzoneFileUpload, FormDialog} from "../../../controls";
import CompanyUuidLookup from "../../Companies/components/CompanyUuidLookup";
import Validator from "../validators/UploadBookingListValidator";


const apiSitePrefix = getApiSitePrefix();

const BookingListUploadDialog = (props) => {
  const classes = props.classes;
  const canEdit = props.canEdit;
  const SystemData = props.systemData;

  const [dialogStates, setDialogStates] = useState(props.dialogStates || {
    showDialog: true,
    record: {},
    title: 'Upload Booking List',
  });

  const processBookingList = async (file) => {
    const buffer = new Uint8Array(await file.arrayBuffer());
    const dataArray = [];
    buffer.forEach((x,i)=>{dataArray[i] = x});

    const headers = {...axios.defaults.headers, 'Content-Type': 'application/json'};

    try {
      const url = "bookings/processBookingList";
      SystemData.toggleLoadingProgress(true, "Processing Booking List");
      const response = await axios.post(
        `${apiSitePrefix}/${url}`,
        { document: JSON.stringify(dataArray) },
        { headers }
      );

      SystemData.toggleLoadingProgress(false);
      if (response && response.data && response.data.success) {
        return {success: response.data.success};
      } else {
        return {
          success: false,
          message: `Booking List could not be processed due to: ${response.data.error}`,
        };
      }
    } catch (err) {
      SystemData.toggleLoadingProgress(false);
      console.error(err);
      return {
        success: false,
        message: `Booking List could not be processed with unexpected error: ${err}`,
      };
    }
  }


  if (dialogStates.showDialog) {
    return (
      <FormDialog
        title={dialogStates.title}
        message={dialogStates.dialogMessage}
        open={dialogStates.showDialog}
        record={dialogStates.record}
        dialogOptions={{width: "sm", maxWidth: "sm", fullWidth: true,  height: "inherit"}}
        classes={classes}
        validator={Validator}
        buttons = {{
          save:{icon: "drive_folder_upload", key: "Upload", label: "Process Booking List", color: "primary", disabled: (status)=>{return status.error}},
          cancel:{icon: "cancel", key: "Cancel", label: "Close", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save") {
            const record = state.record;
            processBookingList(record.file).then(result => {
              if (result.success) {
                SystemData.openAlert("Booking List Upload", "Booking List processing completed successfully");
                setDialogStates({...dialogStates, record: {}});
              } else {
                SystemData.openAlert("Process Booking List Error", "Could not complete processing of the Booking List: " + result.message);
              }
            }).catch(error => {
              SystemData.openAlert("Process Booking List Error", "Unexpected error processing the Excel Booking List: " + error);
              console.log(error);
            });
          } else {
            setDialogStates({...dialogStates, showDialog: false, record: null});
            if (props.close)
              props.close();
          }
        }}

      >
        <Grid container checkChildren={true} spacing={1}>
          <Grid item xs={12} />
          <Grid item xs={12} />
          <Grid item xs={12} checkChildren={true}>
            <div className="d-flex flex-row justify-content-between align-items-center">
              <InputLabel shrink>
                Sales Agent
              </InputLabel>
            <CompanyUuidLookup
              id={"gsaUuid"}
              returnType={"object"}
              companyType={"GSA"}
              alwaysShowCompanyName={true}
              onChange={(returnObject, props)=> {
                if (returnObject.found) {
                  const gsa = returnObject.data
                  const gsaCompanyName = gsa.companyCode === "NEW SUPPLIER" ? "" : gsa.companyName;
                  const data = {
                    ...props.record,
                    gsaCompany: gsa,
                    gsaUuid: gsa.companyUuid,
                    gsaCompanyName: gsaCompanyName,
                  }
                  props.recordChange(data);
                } else {
                  props.onChange(returnObject.value);
                }
              }}
            />
            </div>
          </Grid>
          <Grid item xs={12} />
          <Grid item xs={12} />
          <Grid item xs={12} checkChildren={true}>
            {(record, changeRecord) => (
              <div className="d-flex flex-row justify-content-between align-items-center">
                <InputLabel shrink style={{marginBottom:10}}>
                  Booking List to Process
                </InputLabel>
                <DropzoneFileUpload
                  objectType="BOOKING LIST"
                  tripLegUuid={null}
                  documentUuid={" "}
                  accept=".xls, .xlsx"
                  dropzoneStyle={{ height: 38,  maxHeight: 38, minHeight: 38, border: "1px dashed #929292" }}
                  inputLabel={{fontSize: 17, color: "#fd5b02"}}
                  inputContent={record.fileName && record.fileName !== "" ? record.fileName : "Drop a Booking List Excel File or Click to browse"}
                  disabled={false}
                  onChange={(result, props)=>{
                    if (result && result.success) {
                      const data = {
                        ...props.record,
                        file: result.file,
                        fileName: result.file.name,
                      }
                      props.recordChange(data);
                    }
                  }}
                />
              </div>
            )}
          </Grid>

        </Grid>

      </FormDialog>
    )
  } else {
    return (<></>);
  }
}

export default BookingListUploadDialog;
